export default function HealthCare() {
  const healthItems = [
    { icon: 'ri-stethoscope-line', text: 'Veterinary health check' },
    { icon: 'ri-syringe-line', text: 'Age-appropriate vaccinations' },
    { icon: 'ri-medicine-bottle-line', text: 'Deworming schedule' },
    { icon: 'ri-home-4-line', text: 'Litter training progress' },
    { icon: 'ri-restaurant-line', text: 'High-quality diet plan' },
    { icon: 'ri-scissors-cut-line', text: 'Grooming instructions for Ragdoll coats' },
    { icon: 'ri-emotion-line', text: 'Behavioral expectations' }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-purple-50 to-blue-50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-6">Health & Care Information</h2>
            <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Every Ragdoll Gentle Paws kitten comes with comprehensive health care and detailed information to ensure a smooth transition to your home.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {healthItems.map((item, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 flex items-center"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-400 to-purple-300 rounded-xl flex items-center justify-center mr-5 flex-shrink-0">
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <p className="text-lg font-semibold text-gray-800">{item.text}</p>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-xl text-center">
            <i className="ri-heart-pulse-line text-6xl text-blue-400 mb-6"></i>
            <p className="text-2xl font-bold text-gray-900 mb-4">
              Our care ensures your kitten arrives healthy, happy, and ready to bond.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              We provide everything you need to know to give your new Ragdoll the best start in their forever home.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
